export interface application {
  appName: string;
  moduleId: string;
  activityFunction: (location: Location) => boolean;
}

const authPaths = [
  "login",
  "login/redirect",
  "logout",
  "forgotUsername",
  "forgotPassword",
  "resetPassword",
  "invite/accept",
  "invite/newuser",
  "invite/existinguser"
];

const TI_PATHS_ROOT = "/claims";
const FMS_PATHS_ROOT = "/cam";
const USER_MANAGEMENT_PATHS_ROOT = "/userManagement";
const JOB_SCHEDULER_PATHS_ROOT = "/scheduler";
const ALL_APP_PATHS = [...authPaths];
const ALL_APP_PATH_ROOTS = [TI_PATHS_ROOT, FMS_PATHS_ROOT, USER_MANAGEMENT_PATHS_ROOT, JOB_SCHEDULER_PATHS_ROOT];
const HIDE_SIDEBAR_PATHS: string[] = authPaths.filter(authPath => authPath !== "login");

export const applicationConfigs: application[] = [
  {
    appName: "@nutrien/auth-app",
    moduleId: "@nutrien/auth-app",
    activityFunction: (location: Location) => authPaths.includes(location.pathname.substring(1))
  },
  {
    appName: "@nutrien/sidebar-app",
    moduleId: "@nutrien/sidebar-app",
    activityFunction: () => !HIDE_SIDEBAR_PATHS.includes(location.pathname.substring(1))
  },
  {
    appName: "@nutrien/dashboard-app",
    moduleId: "@nutrien/dashboard-app",
    activityFunction: (location: Location) =>
      !ALL_APP_PATHS.includes(location.pathname.substring(1)) &&
      ALL_APP_PATH_ROOTS.every(pathRoot => !location.pathname.startsWith(pathRoot))
  },
  {
    appName: "@nutrien/transit-insurance-app",
    moduleId: "@nutrien/transit-insurance-app",
    activityFunction: (location: Location) => location.pathname.startsWith(TI_PATHS_ROOT)
  },
  {
    appName: "@nutrien/fms-app",
    moduleId: "@nutrien/fms-app",
    activityFunction: (location: Location) => location.pathname.startsWith(FMS_PATHS_ROOT)
  },
  {
    appName: "@nutrien/user-management-app",
    moduleId: "@nutrien/user-management-app",
    activityFunction: (location: Location) => location.pathname.startsWith(USER_MANAGEMENT_PATHS_ROOT)
  },
  {
    appName: "@nutrien/job-scheduler-app",
    moduleId: "@nutrien/job-scheduler-app",
    activityFunction: (location: Location) => location.pathname.startsWith(JOB_SCHEDULER_PATHS_ROOT)
  }
];
